// tslint:disable-next-line:variable-name
 export const TranslationKeyConstants = {
app:{
title: 'app.title',
brandName: 'app.brand-name'
},
shared:{
emptyString: 'shared.empty-string',
none: 'shared.none',
successMessages:{
title: 'shared.success-messages.title',
resendMessage: 'shared.success-messages.resend-message',
reprocessMessage: 'shared.success-messages.reprocess-message'
},
errorMessages:{
title: 'shared.error-messages.title',
resendMessage: 'shared.error-messages.resend-message',
reprocessMessage: 'shared.error-messages.reprocess-message'
},
validationMessages:{
fromDateBeforeToDate: 'shared.validation-messages.from-date-before-to-date',
fromDateNotInPast: 'shared.validation-messages.from-date-not-in-past'
},
confirmationDelete:{
title: 'shared.confirmation-delete.title',
message: 'shared.confirmation-delete.message',
acceptButton: 'shared.confirmation-delete.accept-button',
rejectButton: 'shared.confirmation-delete.reject-button'
},
detailActionButtons:{
edit: 'shared.detail-action-buttons.edit',
cancel: 'shared.detail-action-buttons.cancel',
save: 'shared.detail-action-buttons.save'
},
validityOverlayPanel:{
valid: 'shared.validity-overlay-panel.valid',
notValid: 'shared.validity-overlay-panel.not-valid',
from: 'shared.validity-overlay-panel.from',
to: 'shared.validity-overlay-panel.to'
},
unknownError: 'shared.unknown-error',
unauthorized: 'shared.unauthorized'
},
dashboard:{
title: 'dashboard.title',
dashboardMessageStatusDetails:{
tableColumnHeaders:{
tradingPartner: 'dashboard.dashboardMessageStatusDetails.tableColumnHeaders.tradingPartner',
messageTypeCode: 'dashboard.dashboardMessageStatusDetails.tableColumnHeaders.messageTypeCode',
direction: 'dashboard.dashboardMessageStatusDetails.tableColumnHeaders.direction',
errorType: 'dashboard.dashboardMessageStatusDetails.tableColumnHeaders.errorType',
tenant: 'dashboard.dashboardMessageStatusDetails.tableColumnHeaders.tenant'
}
},
dashboardMessageFailGraphic:{
checkbox:{
failedMessages: 'dashboard.dashboardMessageFailGraphic.checkbox.failedMessages',
successfulMessages: 'dashboard.dashboardMessageFailGraphic.checkbox.successfulMessages'
}
},
dashboardFilter:{
showDataFromLast: 'dashboard.dashboardFilter.showDataFromLast',
refreshTime: 'dashboard.dashboardFilter.refreshTime'
},
dashboardMessageFailures:{
messagesFailRateAndTenantStatusTitle: 'dashboard.dashboardMessageFailures.messagesFailRateAndTenantStatusTitle',
noDataAvailable: 'dashboard.dashboardMessageFailures.noDataAvailable'
},
dashboardMessageStatuses:{
messageStatusTitle: 'dashboard.dashboardMessageStatuses.messageStatusTitle'
},
dashboardGatewayStatus:{
gatewatStatusTitle: 'dashboard.dashboardGatewayStatus.gatewatStatusTitle',
noDataAvailable: 'dashboard.dashboardGatewayStatus.noDataAvailable'
},
dashboardGatewayStatusDetail:{
inDirection: 'dashboard.dashboardGatewayStatusDetail.inDirection',
outDirection: 'dashboard.dashboardGatewayStatusDetail.outDirection'
},
dashboardGatewayStatusList:{
tableColumnHeaders:{
type: 'dashboard.dashboardGatewayStatusList.tableColumnHeaders.type',
inTiming: 'dashboard.dashboardGatewayStatusList.tableColumnHeaders.inTiming',
outTiming: 'dashboard.dashboardGatewayStatusList.tableColumnHeaders.outTiming'
}
},
dashboardUnknownMessages:{
unknownMessagesTitle: 'dashboard.dashboardUnknownMessages.unknownMessagesTitle',
tableColumnHeaders:{
numberOfMessages: 'dashboard.dashboardUnknownMessages.tableColumnHeaders.numberOfMessages',
communicationPartner: 'dashboard.dashboardUnknownMessages.tableColumnHeaders.communicationPartner'
}
},
secrets:{
title: 'dashboard.secrets.title'
}
},
messagesOverview:{
errorMessages:{
noMessagesSelected: 'messages-overview.error-messages.no-messages-selected',
reprocessNotAllowed: 'messages-overview.error-messages.reprocess-not-allowed',
resendNotAllowed: 'messages-overview.error-messages.resend-not-allowed',
intermediateFormatDownloadNotAllowed: 'messages-overview.error-messages.intermediate-format-download-not-allowed',
imbV6RetryError: 'messages-overview.error-messages.imb-v6-retry-error'
},
title: 'messages-overview.title',
tooltip: 'messages-overview.tooltip',
headerTitle:{
messages: 'messages-overview.header-title.messages',
filter: 'messages-overview.header-title.filter',
addMessages: 'messages-overview.header-title.add-messages'
},
actionButtons:{
download: 'messages-overview.action-buttons.download',
reprocess: 'messages-overview.action-buttons.reprocess',
resend: 'messages-overview.action-buttons.resend',
apply: 'messages-overview.action-buttons.apply',
resetFilters: 'messages-overview.action-buttons.reset-filters',
importMessages: 'messages-overview.action-buttons.import-messages',
resendTooltip: 'messages-overview.action-buttons.resend-tooltip',
reprocessTooltip: 'messages-overview.action-buttons.reprocess-tooltip'
},
tableColumnHeaders:{
createdOn: 'messages-overview.table-column-headers.created-on',
senderInternalCode: 'messages-overview.table-column-headers.sender-internal-code',
receiverInternalCode: 'messages-overview.table-column-headers.receiver-internal-code',
direction: 'messages-overview.table-column-headers.direction',
type: 'messages-overview.table-column-headers.type',
status: 'messages-overview.table-column-headers.status',
externalProtocol: 'messages-overview.table-column-headers.external-protocol',
typeSpecification: 'messages-overview.table-column-headers.type-specification',
isReprocessed: 'messages-overview.table-column-headers.is-reprocessed',
fileName: 'messages-overview.table-column-headers.file-name'
},
filterLabels:{
from: 'messages-overview.filter-labels.from',
to: 'messages-overview.filter-labels.to',
period: 'messages-overview.filter-labels.period',
sender: 'messages-overview.filter-labels.sender',
receiver: 'messages-overview.filter-labels.receiver',
direction: 'messages-overview.filter-labels.direction',
type: 'messages-overview.filter-labels.type',
status: 'messages-overview.filter-labels.status',
freeTextSearch: 'messages-overview.filter-labels.free-text-search',
viewMore: 'messages-overview.filter-labels.view-more',
viewLess: 'messages-overview.filter-labels.view-less',
messageIdentifier: 'messages-overview.filter-labels.messageIdentifier',
externalProtocol: 'messages-overview.filter-labels.external-protocol',
tradingPartner: 'messages-overview.filter-labels.trading-partner',
communicationPartner: 'messages-overview.filter-labels.communication-partner',
externalReference: 'messages-overview.filter-labels.external-reference',
excludeReprocessed: 'messages-overview.filter-labels.exclude-reprocessed',
typeSpecification: 'messages-overview.filter-labels.typeSpecification'
},
importMessages:{
selectFiles: 'messages-overview.import-messages.select-files',
tenant: 'messages-overview.import-messages.tenant',
direction: 'messages-overview.import-messages.direction',
process: 'messages-overview.import-messages.process',
tableColumnHeaders:{
fileName: 'messages-overview.import-messages.table-column-headers.file-name'
},
errorMessages:{
formErrors: 'messages-overview.import-messages.error-messages.form-errors',
selectFileToSend: 'messages-overview.import-messages.error-messages.select-file-to-send',
sendSuccess: 'messages-overview.import-messages.error-messages.send-success'
},
successMessages:{
send: 'messages-overview.import-messages.success-messages.send'
}
}
},
messagesDetail:{
title: 'messages-detail.title',
tooltip: 'messages-detail.tooltip',
headerTitle:{
messageDetail: 'messages-detail.header-title.message-detail'
},
properties:{
title: 'messages-detail.properties.title',
timestamp: 'messages-detail.properties.timestamp',
id: 'messages-detail.properties.id',
messageIdentifier: 'messages-detail.properties.messageIdentifier',
generatedExternalReference: 'messages-detail.properties.generatedExternalReference',
status: 'messages-detail.properties.status',
senderInternalCode: 'messages-detail.properties.senderInternalCode',
receiverInternalCode: 'messages-detail.properties.receiverInternalCode',
direction: 'messages-detail.properties.direction',
communicationSenderCode: 'messages-detail.properties.communicationSenderCode',
communicationReceiverCode: 'messages-detail.properties.communicationReceiverCode',
type: 'messages-detail.properties.type',
externalReference: 'messages-detail.properties.externalReference',
statusErrorTypeSendingFailedText: 'messages-detail.properties.statusErrorTypeSendingFailedText',
statusErrorTypeProcessingFailedText: 'messages-detail.properties.statusErrorTypeProcessingFailedText',
messageSettings: 'messages-detail.properties.messageSettings',
relatedMessages: 'messages-detail.properties.relatedMessages'
},
content:{
acknowledgementReferenceHeader: 'messages-detail.content.acknowledgement-reference-header',
characteristicCode: 'messages-detail.content.characteristic-code',
comReceiver: 'messages-detail.content.com-receiver',
comSender: 'messages-detail.content.com-sender',
contactReference: 'messages-detail.content.contact-reference',
contentHeader: 'messages-detail.content.content-header',
connectionPointHeader: 'messages-detail.content.connection-point-header',
documentId: 'messages-detail.content.document-id',
documentVersion: 'messages-detail.content.document-version',
messageHeader: 'messages-detail.content.message-header',
originalMessageType: 'messages-detail.content.original-message-type',
originalTimestamp: 'messages-detail.content.original-timestamp',
receiver: 'messages-detail.content.receiver',
referenceId: 'messages-detail.content.reference-id',
referenceVersion: 'messages-detail.content.reference-version',
sender: 'messages-detail.content.sender',
internalShipper: 'messages-detail.content.internal-shipper',
externalShipper: 'messages-detail.content.external-shipper',
nominationTypeCode: 'messages-detail.content.nomination-type-code',
quantityTypeCode: 'messages-detail.content.quantity-type-code',
currency: 'messages-detail.content.currency',
unit: 'messages-detail.content.unit',
contractReference: 'messages-detail.content.contract-reference',
period: 'messages-detail.content.period',
status: 'messages-detail.content.status',
dataGridOperator: 'messages-detail.content.data-grid-operator',
splitLast: 'messages-detail.content.split-last',
splitNumber: 'messages-detail.content.split-number',
transparencyTableColumnHeaders:{
from: 'messages-detail.content.transparency-table-column-headers.from',
to: 'messages-detail.content.transparency-table-column-headers.to',
direction: 'messages-detail.content.transparency-table-column-headers.direction',
firmTechnical: 'messages-detail.content.transparency-table-column-headers.firm-technical',
firmBooked: 'messages-detail.content.transparency-table-column-headers.firm-booked',
firmAvailable: 'messages-detail.content.transparency-table-column-headers.firm-available',
interruptibleTotal: 'messages-detail.content.transparency-table-column-headers.interruptible-total',
interruptibleBooked: 'messages-detail.content.transparency-table-column-headers.interruptible-booked',
interruptibleAvailable: 'messages-detail.content.transparency-table-column-headers.interruptible-available',
aggregated: 'messages-detail.content.transparency-table-column-headers.aggregated',
dayAheadUIOLI: 'messages-detail.content.transparency-table-column-headers.dayAheadUIOLI',
grossCalorific: 'messages-detail.content.transparency-table-column-headers.grossCalorific',
interruptibleBookedCapacity: 'messages-detail.content.transparency-table-column-headers.interruptible-booked-capacity',
interruptedCapacity: 'messages-detail.content.transparency-table-column-headers.interrupted-capacity',
interruptedCapacityPercentage: 'messages-detail.content.transparency-table-column-headers.interrupted-capacity-percentage',
auctionPeriod: 'messages-detail.content.transparency-table-column-headers.auction-period',
capacityPeriod: 'messages-detail.content.transparency-table-column-headers.capacity-period',
currencyUnit: 'messages-detail.content.transparency-table-column-headers.currency-unit',
clearedPrice: 'messages-detail.content.transparency-table-column-headers.cleared-price',
reservePrice: 'messages-detail.content.transparency-table-column-headers.reserve-price',
auctionPremium: 'messages-detail.content.transparency-table-column-headers.auction-premium',
allocationProcess: 'messages-detail.content.transparency-table-column-headers.allocation-process',
type: 'messages-detail.content.transparency-table-column-headers.type',
status: 'messages-detail.content.transparency-table-column-headers.status'
},
nominationTableColumnHeaders:{
from: 'messages-detail.content.nomination-table-column-headers.from',
to: 'messages-detail.content.nomination-table-column-headers.to',
direction: 'messages-detail.content.nomination-table-column-headers.direction',
quantity: 'messages-detail.content.nomination-table-column-headers.quantity',
unit: 'messages-detail.content.nomination-table-column-headers.unit'
},
allocationTableColumnHeaders:{
status: 'messages-detail.content.allocation-table-column-headers.status',
from: 'messages-detail.content.allocation-table-column-headers.from',
to: 'messages-detail.content.allocation-table-column-headers.to',
direction: 'messages-detail.content.allocation-table-column-headers.direction',
quantity: 'messages-detail.content.allocation-table-column-headers.quantity',
minQuantity: 'messages-detail.content.allocation-table-column-headers.minQuantity',
maxQuantity: 'messages-detail.content.allocation-table-column-headers.maxQuantity',
unit: 'messages-detail.content.allocation-table-column-headers.unit'
},
otherTableColumnHeaders:{
identification: 'messages-detail.content.other-table-column-headers.identification',
direction: 'messages-detail.content.other-table-column-headers.direction',
quantity: 'messages-detail.content.other-table-column-headers.quantity',
deliveryPeriod: 'messages-detail.content.other-table-column-headers.deliveryPeriod',
leadTime: 'messages-detail.content.other-table-column-headers.leadTime',
price: 'messages-detail.content.other-table-column-headers.price'
},
cmsfeedbackerrorTableColumnHeaders:{
errorCode: 'messages-detail.content.cmsfeedbackerror-table-column-headers.errorCode',
errorDescription: 'messages-detail.content.cmsfeedbackerror-table-column-headers.errorDescription'
},
cmsclientproductionswitchTableColumnHeaders:{
period: 'messages-detail.content.cmsclientproductionswitch-table-column-headers.period',
arsEan: 'messages-detail.content.cmsclientproductionswitch-table-column-headers.arsEan',
direction: 'messages-detail.content.cmsclientproductionswitch-table-column-headers.direction',
messageGuid: 'messages-detail.content.cmsclientproductionswitch-table-column-headers.messageGuid',
rlpEan: 'messages-detail.content.cmsclientproductionswitch-table-column-headers.rlpEan',
shipperEan: 'messages-detail.content.cmsclientproductionswitch-table-column-headers.shipperEan',
rlpMeas: 'messages-detail.content.cmsclientproductionswitch-table-column-headers.rlpMeas',
rlpName: 'messages-detail.content.cmsclientproductionswitch-table-column-headers.rlpName'
}
},
actionButtons:{
download: 'messages-detail.action-buttons.download',
reprocess: 'messages-detail.action-buttons.reprocess',
resend: 'messages-detail.action-buttons.resend'
},
tabViews:{
content:{
title: 'messages-detail.tab-views.content.title'
},
formats:{
title: 'messages-detail.tab-views.formats.title',
originalFormat: 'messages-detail.tab-views.formats.originalFormat',
transformedFormat: 'messages-detail.tab-views.formats.transformedFormat',
download: 'messages-detail.tab-views.formats.download'
},
history:{
title: 'messages-detail.tab-views.history.title'
}
}
},
partners:{
title: 'partners.title',
tooltip: 'partners.tooltip',
headerTitle:{
partners: 'partners.header-title.partners'
},
newPartner: 'partners.new-partner',
searchPartners: 'partners.search-partners',
partnersOverview:{
tableColumnHeaders:{
isActive: 'partners.partners-overview.table-column-headers.is-active',
name: 'partners.partners-overview.table-column-headers.name',
connectCode: 'partners.partners-overview.table-column-headers.connect-code',
partnerCode: 'partners.partners-overview.table-column-headers.partner-code',
roles: 'partners.partners-overview.table-column-headers.roles'
}
},
partnerDetail:{
title: 'partners.partner-detail.title',
errorMessages:{
formErrors: 'partners.partner-detail.error-messages.form-errors',
saveError: 'partners.partner-detail.error-messages.save-error',
maintenanceModeFetchError: 'partners.partner-detail.error-messages.maintenance-mode-fetch-error',
maintenanceModeToggleError: 'partners.partner-detail.error-messages.maintenance-mode-toggle-error',
maintenanceModeToggledOn: 'partners.partner-detail.error-messages.maintenance-mode-toggled-on',
maintenanceModeToggledOff: 'partners.partner-detail.error-messages.maintenance-mode-toggled-off'
},
successMessages:{
saveSuccess: 'partners.partner-detail.success-messages.save-success'
},
validationMessages:{
existingConnectCode: 'partners.partner-detail.validation-messages.existing-connect-code',
existingPartnerName: 'partners.partner-detail.validation-messages.existing-partner-name',
requiredRole: 'partners.partner-detail.validation-messages.required-role',
hasActiveMessageSettings: 'partners.partner-detail.validation-messages.has-active-message-settings',
hasActiveCommunicationProfiles: 'partners.partner-detail.validation-messages.has-active-communication-profiles'
},
linkText: 'partners.partner-detail.link-text',
form:{
partnerHeader: 'partners.partner-detail.form.partner-header',
rolesHeader: 'partners.partner-detail.form.roles-header',
technicalContactsHeader: 'partners.partner-detail.form.technical-contacts-header',
translationCodesHeader: 'partners.partner-detail.form.translation-codes-header'
},
buttons:{
mailAll: 'partners.partner-detail.buttons.mail-all',
copyAddresses: 'partners.partner-detail.buttons.copy-addresses',
addPartnerContact: 'partners.partner-detail.buttons.add-partner-contact',
addCode: 'partners.partner-detail.buttons.add-code'
},
labels:{
name: 'partners.partner-detail.labels.name',
connectCode: 'partners.partner-detail.labels.connect-code',
validFrom: 'partners.partner-detail.labels.valid-from',
validTo: 'partners.partner-detail.labels.valid-to',
rolesCheckbox:{
trading: 'partners.partner-detail.labels.roles-checkbox.trading',
communication: 'partners.partner-detail.labels.roles-checkbox.communication',
belongsToEaseeGasGroup: 'partners.partner-detail.labels.roles-checkbox.belongsToEaseeGasGroup'
},
contacts:{
name: 'partners.partner-detail.labels.contacts.name',
telephone: 'partners.partner-detail.labels.contacts.telephone',
email: 'partners.partner-detail.labels.contacts.email'
},
partnerCodes:{
code: 'partners.partner-detail.labels.partner-codes.code'
}
},
tenants:{
header: 'partners.partner-detail.tenants.header',
subtitle: 'partners.partner-detail.tenants.subtitle'
},
communicationProfiles:{
header: 'partners.partner-detail.communication-profiles.header'
},
none: 'partners.partner-detail.none',
noTranslationCodes: 'partners.partner-detail.no-translation-codes',
noTenantCodes: 'partners.partner-detail.no-tenant-codes',
noContacts: 'partners.partner-detail.no-contacts'
}
},
codeTranslation:{
title: 'code-translation.title',
tooltip: 'code-translation.tooltip',
search: 'code-translation.search',
headerTitle:{
codeTranslation: 'code-translation.header-title.code-translation'
},
tabViews:{
partnersHeader: 'code-translation.tab-views.partners-header',
connectionPointHeader: 'code-translation.tab-views.connection-point-header',
shipperAccountHeader: 'code-translation.tab-views.shipper-account-header',
contractReferenceHeader: 'code-translation.tab-views.contract-reference-header'
},
buttons:{
newCodeTranslation: 'code-translation.buttons.new-code-translation'
},
tableColumnHeaders:{
displayName: 'code-translation.table-column-headers.display-name',
tenant: 'code-translation.table-column-headers.tenant',
internalCode: 'code-translation.table-column-headers.internal-code',
externalCode: 'code-translation.table-column-headers.external-code',
codingType: 'code-translation.table-column-headers.coding-type'
},
partnerTableColumnHeaders:{
partnerName: 'code-translation.partner-table-column-headers.partner-name',
code: 'code-translation.partner-table-column-headers.code',
usage: 'code-translation.partner-table-column-headers.usage',
tenant: 'code-translation.partner-table-column-headers.tenant',
type: 'code-translation.partner-table-column-headers.type'
},
errorMessages:{
saveError: 'code-translation.error-messages.save-error',
deleteError: 'code-translation.error-messages.delete-error',
existingCodeTranslation: 'code-translation.error-messages.existing-code-translation',
existingCodeTranslationCombination: 'code-translation.error-messages.existing-code-translation-combination',
deletionNotAllowedCodeTranslation: 'code-translation.error-messages.deletion-not-allowed-code-translation'
},
successMessages:{
saveSuccess: 'code-translation.success-messages.save-success',
deleteSuccess: 'code-translation.success-messages.delete-success'
}
},
messageSettings:{
title: 'message-settings.title',
tooltip: 'message-settings.tooltip',
headerTitle:{
messageSettingsOverview: 'message-settings.header-title.message-settings-overview'
},
newMessageSetting: 'message-settings.new-message-setting',
messageSettingsOverview:{
tableColumnHeaders:{
isActive: 'message-settings.message-settings-overview.table-column-headers.is-active',
tenant: 'message-settings.message-settings-overview.table-column-headers.tenant',
correspondent: 'message-settings.message-settings-overview.table-column-headers.correspondent',
internalCode: 'message-settings.message-settings-overview.table-column-headers.internalCode',
direction: 'message-settings.message-settings-overview.table-column-headers.direction',
communicationProfile: 'message-settings.message-settings-overview.table-column-headers.communication-profile',
messageType: 'message-settings.message-settings-overview.table-column-headers.message-type',
specification: 'message-settings.message-settings-overview.table-column-headers.specification',
extensionParameter: 'message-settings.message-settings-overview.table-column-headers.extension-parameter',
isExcluded: 'message-settings.message-settings-overview.table-column-headers.is-excluded'
}
},
messageSettingsDetail:{
title: 'message-settings.message-settings-detail.title',
extensionParametersTitle: 'message-settings.message-settings-detail.extensionParametersTitle',
errorMessages:{
formErrors: 'message-settings.message-settings-detail.error-messages.form-errors',
saveError: 'message-settings.message-settings-detail.error-messages.save-error'
},
successMessages:{
saveSuccess: 'message-settings.message-settings-detail.success-messages.save-success'
},
validationMessages:{
messageSettingCombinationExists: 'message-settings.message-settings-detail.validation-messages.message-setting-combination-exists'
},
linkText: 'message-settings.message-settings-detail.link-text',
form:{
generalHeader: 'message-settings.message-settings-detail.form.general-header',
deliveryHeader: 'message-settings.message-settings-detail.form.delivery-header',
validationPeriodHeader: 'message-settings.message-settings-detail.form.validation-period-header',
codingHeader: 'message-settings.message-settings-detail.form.coding-header'
},
modal:{
header: 'message-settings.message-settings-detail.modal.header',
buttonPrimary: 'message-settings.message-settings-detail.modal.button-primary',
buttonSecondary: 'message-settings.message-settings-detail.modal.button-secondary'
},
labels:{
tenant: 'message-settings.message-settings-detail.labels.tenant',
correspondent: 'message-settings.message-settings-detail.labels.correspondent',
messageTypeCode: 'message-settings.message-settings-detail.labels.message-type-code',
specification: 'message-settings.message-settings-detail.labels.specification',
standard: 'message-settings.message-settings-detail.labels.standard',
format: 'message-settings.message-settings-detail.labels.format',
version: 'message-settings.message-settings-detail.labels.version',
direction: 'message-settings.message-settings-detail.labels.direction',
maximumDelayDelivery: 'message-settings.message-settings-detail.labels.maximum-delay-delivery',
maximumDelayAcknowledgement: 'message-settings.message-settings-detail.labels.maximum-delay-acknowledgement',
communicationReceiver: 'message-settings.message-settings-detail.labels.communication-receiver',
requireAcknowledgement: 'message-settings.message-settings-detail.labels.require-acknowledgement',
excluded: 'message-settings.message-settings-detail.labels.excluded',
validFrom: 'message-settings.message-settings-detail.labels.valid-from',
validTo: 'message-settings.message-settings-detail.labels.valid-to',
senderCodingType: 'message-settings.message-settings-detail.labels.sender-coding-type',
receiverCodingType: 'message-settings.message-settings-detail.labels.receiver-coding-type',
comSenderCodingType: 'message-settings.message-settings-detail.labels.com-sender-coding-type',
comReceiverCodingType: 'message-settings.message-settings-detail.labels.com-receiver-coding-type',
internalShipperAccountCodingType: 'message-settings.message-settings-detail.labels.internal-shipper-account-coding-type',
externalShipperAccountCodingType: 'message-settings.message-settings-detail.labels.external-shipper-account-coding-type',
connectionPointCodingType: 'message-settings.message-settings-detail.labels.connection-point-coding-type',
senderRole: 'message-settings.message-settings-detail.labels.sender-role',
receiverRole: 'message-settings.message-settings-detail.labels.receiver-role',
serviceName: 'message-settings.message-settings-detail.labels.service-name',
documentType: 'message-settings.message-settings-detail.labels.document-type'
},
extensionParameters:{
title: 'message-settings.message-settings-detail.extensionParameters.title',
isActive: 'message-settings.message-settings-detail.extensionParameters.is-active',
communication: 'message-settings.message-settings-detail.extensionParameters.communication',
processingMode: 'message-settings.message-settings-detail.extensionParameters.processingMode',
partner: 'message-settings.message-settings-detail.extensionParameters.partner',
columnHeaders:{
type: 'message-settings.message-settings-detail.extensionParameters.column-headers.type',
configuration: 'message-settings.message-settings-detail.extensionParameters.column-headers.configuration'
}
}
}
},
communicationProfiles:{
title: 'communication-profiles.title',
tooltip: 'communication-profiles.tooltip',
headerTitle:{
communicationProfilesOverview: 'communication-profiles.header-title.communication-profiles-overview'
},
newCommunicationProfile: 'communication-profiles.new-communication-profile',
communicationProfilesOverview:{
tableColumnHeaders:{
isActive: 'communication-profiles.communication-profiles-overview.table-column-headers.is-active',
name: 'communication-profiles.communication-profiles-overview.table-column-headers.name',
partnerName: 'communication-profiles.communication-profiles-overview.table-column-headers.partner-name',
connectCode: 'communication-profiles.communication-profiles-overview.table-column-headers.connect-code',
protocol: 'communication-profiles.communication-profiles-overview.table-column-headers.protocol'
}
},
communicationProfilesDetail:{
title: 'communication-profiles.communication-profiles-detail.title',
errorMessages:{
formErrors: 'communication-profiles.communication-profiles-detail.error-messages.form-errors',
saveError: 'communication-profiles.communication-profiles-detail.error-messages.save-error',
startDateBeforeEndDate: 'communication-profiles.communication-profiles-detail.error-messages.start-date-before-end-date',
dateNotInPast: 'communication-profiles.communication-profiles-detail.error-messages.date-not-in-past',
datesOverlapping: 'communication-profiles.communication-profiles-detail.error-messages.dates-overlapping',
secretsOverlap: 'communication-profiles.communication-profiles-detail.error-messages.secrets-overlap',
singleActiveAgreement: 'communication-profiles.communication-profiles-detail.error-messages.single-active-agreement',
duplicateException: 'communication-profiles.communication-profiles-detail.error-messages.duplicate-exception',
atLeastOneActiveAgreement: 'communication-profiles.communication-profiles-detail.error-messages.at-least-one-active-agreement',
duplicateAgreementReference: 'communication-profiles.communication-profiles-detail.error-messages.duplicate-agreement-reference'
},
successMessages:{
saveSuccess: 'communication-profiles.communication-profiles-detail.success-messages.save-success'
},
linkText: 'communication-profiles.communication-profiles-detail.link-text',
form:{
generalHeader: 'communication-profiles.communication-profiles-detail.form.general-header',
validationPeriodHeader: 'communication-profiles.communication-profiles-detail.form.validation-period-header',
queueDetailsHeader: 'communication-profiles.communication-profiles-detail.form.queue-details-header',
amqpGeneralHeader: 'communication-profiles.communication-profiles-detail.form.amqp-general-header',
restGeneralHeader: 'communication-profiles.communication-profiles-detail.form.rest-general-header',
as2GeneralHeader: 'communication-profiles.communication-profiles-detail.form.as2-general-header',
as4GeneralHeader: 'communication-profiles.communication-profiles-detail.form.as4-general-header',
as4AdvancedHeader: 'communication-profiles.communication-profiles-detail.form.as4-advanced-header',
as4MessageRelatedHeader: 'communication-profiles.communication-profiles-detail.form.as4-message-related-header',
as4AgreementReferencesHeader: 'communication-profiles.communication-profiles-detail.form.as4-agreement-references-header',
errorDatesOverlap: 'communication-profiles.communication-profiles-detail.form.error-dates-overlap',
add: 'communication-profiles.communication-profiles-detail.form.add'
},
modal:{
header: 'communication-profiles.communication-profiles-detail.modal.header',
message: 'communication-profiles.communication-profiles-detail.modal.message',
buttonPrimary: 'communication-profiles.communication-profiles-detail.modal.button-primary',
buttonSecondary: 'communication-profiles.communication-profiles-detail.modal.button-secondary'
},
labels:{
name: 'communication-profiles.communication-profiles-detail.labels.name',
retryStrategy: 'communication-profiles.communication-profiles-detail.labels.retry-strategy',
acknowledgementMaximumDelay: 'communication-profiles.communication-profiles-detail.labels.acknowledgementMaximumDelay',
backUpCommunicationProfile: 'communication-profiles.communication-profiles-detail.labels.back-up-communication-profile',
communicationPartnerId: 'communication-profiles.communication-profiles-detail.labels.communication-partner-id',
validFrom: 'communication-profiles.communication-profiles-detail.labels.valid-from',
validTo: 'communication-profiles.communication-profiles-detail.labels.valid-to',
communicationProtocolCode: 'communication-profiles.communication-profiles-detail.labels.communication-protocol-code',
queueName: 'communication-profiles.communication-profiles-detail.labels.queue-name',
messageEnvelope: 'communication-profiles.communication-profiles-detail.labels.message-envelope',
transportType: 'communication-profiles.communication-profiles-detail.labels.transport-type',
deliveryUri: 'communication-profiles.communication-profiles-detail.labels.delivery-uri',
uri: 'communication-profiles.communication-profiles-detail.labels.uri',
selfAs4Reference: 'communication-profiles.communication-profiles-detail.labels.self-as4-reference',
selfAs2Reference: 'communication-profiles.communication-profiles-detail.labels.self-as2-reference',
partnerAs4Reference: 'communication-profiles.communication-profiles-detail.labels.partner-as4-reference',
partnerAs2Reference: 'communication-profiles.communication-profiles-detail.labels.partner-as2-reference',
agreementReference: 'communication-profiles.communication-profiles-detail.labels.agreement-reference',
signatureAlgorithm: 'communication-profiles.communication-profiles-detail.labels.signature-algorithm',
encryptionAlgorithm: 'communication-profiles.communication-profiles-detail.labels.encryption-algorithm',
contentType: 'communication-profiles.communication-profiles-detail.labels.content-type',
encryptionSecurityTokenFormat: 'communication-profiles.communication-profiles-detail.labels.encryption-security-token-format',
mgf1HashAlgorithm: 'communication-profiles.communication-profiles-detail.labels.mgf1-hash-algorithm',
rsaHashAlgorithm: 'communication-profiles.communication-profiles-detail.labels.rsa-hash-algorithm',
signingSecurityTokenFormat: 'communication-profiles.communication-profiles-detail.labels.signing-security-token-format',
senderRole: 'communication-profiles.communication-profiles-detail.labels.sender-role',
senderIdType: 'communication-profiles.communication-profiles-detail.labels.sender-id-type',
receiverRole: 'communication-profiles.communication-profiles-detail.labels.receiver-role',
receiverIdType: 'communication-profiles.communication-profiles-detail.labels.receiver-id-type',
serviceName: 'communication-profiles.communication-profiles-detail.labels.service-name',
serviceType: 'communication-profiles.communication-profiles-detail.labels.service-type',
serviceAction: 'communication-profiles.communication-profiles-detail.labels.service-action',
documentType: 'communication-profiles.communication-profiles-detail.labels.document-type',
mdnRequired: 'communication-profiles.communication-profiles-detail.labels.mdn-required',
specifyActualContentType: 'communication-profiles.communication-profiles-detail.labels.specify-actual-content-type',
useFilename: 'communication-profiles.communication-profiles-detail.labels.use-filename',
forceSendBinaryContentTransferEncoding: 'communication-profiles.communication-profiles-detail.labels.force-send-binary-content-transfer-encoding',
sendCompressedPayload: 'communication-profiles.communication-profiles-detail.labels.send-compressed-payload',
useOaep: 'communication-profiles.communication-profiles-detail.labels.use-oaep',
testMessage: 'communication-profiles.communication-profiles-detail.labels.test-message',
deliveryFolder: 'communication-profiles.communication-profiles-detail.labels.deliveryFolder',
deliveryUploadFolder: 'communication-profiles.communication-profiles-detail.labels.deliveryUploadFolder',
receiptFolder: 'communication-profiles.communication-profiles-detail.labels.receiptFolder',
receiptArchiveFolder: 'communication-profiles.communication-profiles-detail.labels.receiptArchiveFolder',
hostUri: 'communication-profiles.communication-profiles-detail.labels.hostUri',
port: 'communication-profiles.communication-profiles-detail.labels.port',
userName: 'communication-profiles.communication-profiles-detail.labels.userName',
password: 'communication-profiles.communication-profiles-detail.labels.password',
staticHeader: 'communication-profiles.communication-profiles-detail.labels.staticHeader',
sslMode: 'communication-profiles.communication-profiles-detail.labels.sslMode',
isPassive: 'communication-profiles.communication-profiles-detail.labels.isPassive',
isReliable: 'communication-profiles.communication-profiles-detail.labels.isReliable',
soapImplementationType: 'communication-profiles.communication-profiles-detail.labels.soap-implementation-type',
soapClientCredentialType: 'communication-profiles.communication-profiles-detail.labels.soap-client-credential-type',
soapSecurityModeType: 'communication-profiles.communication-profiles-detail.labels.soap-security-mode-type',
pollingInterval: 'communication-profiles.communication-profiles-detail.labels.polling-interval',
isActive: 'communication-profiles.communication-profiles-detail.labels.isActive',
libraryId: 'communication-profiles.communication-profiles-detail.labels.libraryId',
applicationId: 'communication-profiles.communication-profiles-detail.labels.applicationId',
destinationLocation: 'communication-profiles.communication-profiles-detail.labels.destinationLocation',
authorityUrl: 'communication-profiles.communication-profiles-detail.labels.authorityUrl',
restProtocolAuthorization: 'communication-profiles.communication-profiles-detail.labels.rest-Protocol-Authorization',
oAuthClientId: 'communication-profiles.communication-profiles-detail.labels.oAuth-Client-Id',
oAuthScope: 'communication-profiles.communication-profiles-detail.labels.oAuth-Scope',
oAuthKeyName: 'communication-profiles.communication-profiles-detail.labels.oAuth-Key-Name',
oAuthAudience: 'communication-profiles.communication-profiles-detail.labels.oAuth-Audience'
},
entsog:{
labels:{
pModeId: 'communication-profiles.communication-profiles-detail.entsog.labels.pMode-id',
pModeDescription: 'communication-profiles.communication-profiles-detail.entsog.labels.pMode-description',
pModeConfigurationOverrides: 'communication-profiles.communication-profiles-detail.entsog.labels.pMode-configuration-overrides',
pModeConfigurationOverridesKey: 'communication-profiles.communication-profiles-detail.entsog.labels.pMode-configuration-overrides-key',
pModeConfigurationOverridesValue: 'communication-profiles.communication-profiles-detail.entsog.labels.pMode-configuration-overrides-value'
}
},
secrets:{
title: 'communication-profiles.communication-profiles-detail.secrets.title',
labels:{
name: 'communication-profiles.communication-profiles-detail.secrets.labels.name',
type: 'communication-profiles.communication-profiles-detail.secrets.labels.type'
},
add: 'communication-profiles.communication-profiles-detail.secrets.add',
certificatesPgpSshKeys: 'communication-profiles.communication-profiles-detail.secrets.certificates-pgp-ssh-keys',
usage: 'communication-profiles.communication-profiles-detail.secrets.usage',
validFrom: 'communication-profiles.communication-profiles-detail.secrets.valid-from',
validTo: 'communication-profiles.communication-profiles-detail.secrets.valid-to',
table:{
type: 'communication-profiles.communication-profiles-detail.secrets.table.type',
subtype: 'communication-profiles.communication-profiles-detail.secrets.table.subtype',
serialNumber: 'communication-profiles.communication-profiles-detail.secrets.table.serial-number',
comment: 'communication-profiles.communication-profiles-detail.secrets.table.comment',
name: 'communication-profiles.communication-profiles-detail.secrets.table.name',
usage: 'communication-profiles.communication-profiles-detail.secrets.table.usage',
validFrom: 'communication-profiles.communication-profiles-detail.secrets.table.valid-from',
validTo: 'communication-profiles.communication-profiles-detail.secrets.table.valid-to',
default: 'communication-profiles.communication-profiles-detail.secrets.table.default',
revoked: 'communication-profiles.communication-profiles-detail.secrets.table.revoked',
errorCannotAdd: 'communication-profiles.communication-profiles-detail.secrets.table.error-cannot-add',
noSecret: 'communication-profiles.communication-profiles-detail.secrets.table.no-secret',
noSecretAgreementref: 'communication-profiles.communication-profiles-detail.secrets.table.no-secret-agreementref'
}
},
implementationParameters:{
title: 'communication-profiles.communication-profiles-detail.implementationParameters.title',
type: 'communication-profiles.communication-profiles-detail.implementationParameters.type',
config: 'communication-profiles.communication-profiles-detail.implementationParameters.config'
}
}
},
secrets:{
title: 'secrets.title',
headerTitle:{
secretsOverview: 'secrets.header-title.secrets-overview'
},
secretsOverview:{
tableColumnHeaders:{
type: 'secrets.secrets-overview.table-column-headers.type',
subType: 'secrets.secrets-overview.table-column-headers.sub-type',
owner: 'secrets.secrets-overview.table-column-headers.owner',
serialNumber: 'secrets.secrets-overview.table-column-headers.serial-number',
comment: 'secrets.secrets-overview.table-column-headers.comment',
validFrom: 'secrets.secrets-overview.table-column-headers.valid-from',
validTo: 'secrets.secrets-overview.table-column-headers.valid-to',
revoked: 'secrets.secrets-overview.table-column-headers.revoked',
passPhrase: 'secrets.secrets-overview.table-column-headers.pass-phrase'
},
errorMessages:{
deleteForeignKeySecrets: 'secrets.secrets-overview.error-messages.delete-foreign-key-secrets'
},
successMessages:{
saveSuccess: 'secrets.secrets-overview.success-messages.save-success',
deleteSuccess: 'secrets.secrets-overview.success-messages.delete-success'
}
},
secretDetail:{
errorMessages:{
formErrors: 'secrets.secret-detail.error-messages.form-errors'
},
titleFormat:{
format: 'secrets.secret-detail.title-format.format',
certificate: 'secrets.secret-detail.title-format.certificate',
pgpKey: 'secrets.secret-detail.title-format.pgp-key',
sshKey: 'secrets.secret-detail.title-format.ssh-key',
ecdsaKey: 'secrets.secret-detail.title-format.ecdsa-key',
eddsahKey: 'secrets.secret-detail.title-format.eddsa-key',
public: 'secrets.secret-detail.title-format.public',
private: 'secrets.secret-detail.title-format.private'
},
linkText: 'secrets.secret-detail.link-text',
form:{
generalHeader: 'secrets.secret-detail.form.general-header',
restrictionHeader: 'secrets.secret-detail.form.restriction-header',
validationPeriodHeader: 'secrets.secret-detail.form.validation-period-header'
},
labels:{
owner: 'secrets.secret-detail.labels.owner',
serialNumber: 'secrets.secret-detail.labels.serial-number',
comment: 'secrets.secret-detail.labels.comment',
revoked: 'secrets.secret-detail.labels.revoked',
validFrom: 'secrets.secret-detail.labels.valid-from',
validTo: 'secrets.secret-detail.labels.valid-to',
passPhrase: 'secrets.secret-detail.labels.pass-phrase'
}
},
newSecret:{
titleFormat:{
format: 'secrets.new-secret.title-format.format',
certificate: 'secrets.new-secret.title-format.certificate',
pgpKey: 'secrets.new-secret.title-format.pgp-key',
sshKey: 'secrets.new-secret.title-format.ssh-key',
ecdsaKey: 'secrets.new-secret.title-format.ecdsa-key',
eddsahKey: 'secrets.new-secret.title-format.eddsa-key',
public: 'secrets.new-secret.title-format.public',
private: 'secrets.new-secret.title-format.private'
},
type: 'secrets.new-secret.type',
subType: 'secrets.new-secret.sub-type',
selectFilePublicLabel: 'secrets.new-secret.select-file-public-label',
selectFile: 'secrets.new-secret.select-file',
next: 'secrets.new-secret.next',
previous: 'secrets.new-secret.previous',
owner: 'secrets.new-secret.owner',
serialNumber: 'secrets.new-secret.serial-number',
validFrom: 'secrets.new-secret.valid-from',
validTo: 'secrets.new-secret.valid-to',
comment: 'secrets.new-secret.comment',
add: 'secrets.new-secret.add',
name: 'secrets.new-secret.name',
privateCertificateSerialNumber: 'secrets.new-secret.private-certificate-serial-number',
privateCertificateNotFoundError: 'secrets.new-secret.private-certificate-not-found-error',
passPhrase: 'secrets.new-secret.pass-phrase'
}
},
agreementUpdates:{
agreementUpdate: 'agreement-updates.agreement-update',
agreementTermination: 'agreement-updates.agreement-termination',
title: 'agreement-updates.title',
agreementUpdatesOverview:{
tableColumnHeaders:{
timestamp: 'agreement-updates.agreement-updates-overview.table-column-headers.timestamp',
requestor: 'agreement-updates.agreement-updates-overview.table-column-headers.requestor',
status: 'agreement-updates.agreement-updates-overview.table-column-headers.status',
recipient: 'agreement-updates.agreement-updates-overview.table-column-headers.recipient',
type: 'agreement-updates.agreement-updates-overview.table-column-headers.type'
}
},
detail:{
title: 'agreement-updates.detail.title',
refuseMissingReason: 'agreement-updates.detail.refuse-missing-reason',
refuseMissingDescription: 'agreement-updates.detail.refuse-missing-description',
requestTitle: 'agreement-updates.detail.request-title',
responseTitle: 'agreement-updates.detail.response-title',
decision: 'agreement-updates.detail.decision',
accept: 'agreement-updates.detail.accept',
refuse: 'agreement-updates.detail.refuse',
refusalReason: 'agreement-updates.detail.refusal-reason',
refusalDescription: 'agreement-updates.detail.refusal-description',
waitingForResponse: 'agreement-updates.detail.waiting-for-response'
},
terminationDetail:{
title: 'agreement-updates.terminationDetail.title',
refuseMissingReason: 'agreement-updates.terminationDetail.refuse-missing-reason',
refuseMissingDescription: 'agreement-updates.terminationDetail.refuse-missing-description',
requestTitle: 'agreement-updates.terminationDetail.request-title',
responseTitle: 'agreement-updates.terminationDetail.response-title',
decision: 'agreement-updates.terminationDetail.decision',
accept: 'agreement-updates.terminationDetail.accept',
refuse: 'agreement-updates.terminationDetail.refuse',
refusalReason: 'agreement-updates.terminationDetail.refusal-reason',
refusalDescription: 'agreement-updates.terminationDetail.refusal-description',
waitingForResponse: 'agreement-updates.terminationDetail.waiting-for-response'
},
messageProperties:{
title: 'agreement-updates.message-properties.title',
requestTimestamp: 'agreement-updates.message-properties.requestTimestamp',
requestConnectMessageID: 'agreement-updates.message-properties.requestConnectMessageID',
responseConnectMessageID: 'agreement-updates.message-properties.responseConnectMessageID',
responseTimestamp: 'agreement-updates.message-properties.responseTimestamp',
expirationTimestamp: 'agreement-updates.message-properties.expirationTimestamp',
status: 'agreement-updates.message-properties.status'
},
createAgreement:{
createAgreementRequest: 'agreement-updates.create-agreement.create-agreement-request',
createAgreementUpdate: 'agreement-updates.create-agreement.create-agreement-update',
title: 'agreement-updates.create-agreement.title',
respondBy: 'agreement-updates.create-agreement.respond-by',
activateBy: 'agreement-updates.create-agreement.activate-by',
expireBy: 'agreement-updates.create-agreement.expire-by',
uploadCertificate: 'agreement-updates.create-agreement.upload-certificate',
cancelRequest: 'agreement-updates.create-agreement.cancel-request',
sendRequest: 'agreement-updates.create-agreement.send-request',
reason: 'agreement-updates.create-agreement.reason',
agreementRequestSent: 'agreement-updates.create-agreement.agreement-request-sent',
respondDateNotSelected: 'agreement-updates.create-agreement.respond-date-not-selected',
activateDateNotSelected: 'agreement-updates.create-agreement.activate-date-not-selected',
certificateNotSeleted: 'agreement-updates.create-agreement.certificate-not-seleted',
dateInPast: 'agreement-updates.create-agreement.date-in-past',
activateByShouldBeGreater: 'agreement-updates.create-agreement.activate-by-should-be-greater',
selectFile: 'agreement-updates.create-agreement.select-file',
communicationProfile: 'agreement-updates.create-agreement.communication-profile'
},
terminateAgreement:{
createAgreementTermination: 'agreement-updates.terminate-agreement.create-agreement-termination',
title: 'agreement-updates.terminate-agreement.title',
agreementReferenceStillActive: 'agreement-updates.terminate-agreement.agreement-reference-still-active',
respondBy: 'agreement-updates.terminate-agreement.respond-by',
respondByBeforeTerminateBy: 'agreement-updates.terminate-agreement.respond-by-before-terminate-by',
respondByNotInPast: 'agreement-updates.terminate-agreement.respond-by-not-in-past',
terminateBy: 'agreement-updates.terminate-agreement.terminate-by',
terminateByNotInPast: 'agreement-updates.terminate-agreement.terminate-by-not-in-past',
reason: 'agreement-updates.terminate-agreement.reason',
agreementReference: 'agreement-updates.terminate-agreement.agreement-reference',
uploadCertificate: 'agreement-updates.terminate-agreement.upload-certificate',
cancelRequest: 'agreement-updates.terminate-agreement.cancel-request',
sendRequest: 'agreement-updates.terminate-agreement.send-request',
agreementTerminationSent: 'agreement-updates.terminate-agreement.agreement-termination-sent',
respondDateNotSelected: 'agreement-updates.terminate-agreement.respond-date-not-selected',
terminateDateNotSelected: 'agreement-updates.terminate-agreement.terminate-date-not-selected',
communicationProfileNotSelected: 'agreement-updates.terminate-agreement.communication-profile-not-selected',
certificateNotSelected: 'agreement-updates.terminate-agreement.certificate-not-selected',
dateInPast: 'agreement-updates.terminate-agreement.date-in-past',
activateByShouldBeGreater: 'agreement-updates.terminate-agreement.activate-by-should-be-greater'
}
},
information:{
fluxys:{
freeTextSearch: 'information.fluxys.free-text-search'
},
messaging:{
folderStructure: 'information.messaging.folder-Structure',
}
},
primeng: 'primeng'
};
